/**
 * LiveMobileClock — Prompt 18B2-P6A §2 · §3 · §4.
 *
 * Owns ONE ticking `now` state and renders the digital HH:MM.
 * TES-B2C1B1M — digital time only; the analog face is no longer
 * rendered. The tick is isolated to this subtree; no other Employee
 * Mobile state or API is touched.
 *
 * Timezone behavior is unchanged (§5): we use the device's local
 * `Date` methods, exactly like P6 did.
 */
import { useLiveNow }
    from "@/components/workforce/mobile/AnalogClock";

function _formatHM(d) {
    return `${String(d.getHours()).padStart(2, "0")}:${
        String(d.getMinutes()).padStart(2, "0")}`;
}

export function LiveMobileClock({ intervalMs = 15_000 }) {
    const now = useLiveNow(intervalMs);
    return (
        <div
            data-testid="mobile-live-clock"
            className="flex flex-col items-center"
        >
            <div
                data-testid="mobile-digital-time"
                className="text-neutral-900 text-[64px] leading-none
                            tabular-nums tracking-[-0.03em]"
                style={{
                    fontFamily:
                        "-apple-system, BlinkMacSystemFont, "
                        + "'Segoe UI', system-ui, sans-serif",
                    fontWeight: 300,
                }}
            >
                {_formatHM(now)}
            </div>
        </div>
    );
}

export default LiveMobileClock;
